<template>
  <div class="container">
    <h2 class="payment-title">微信支付配置</h2>
    <a-form
      :model="config"
      class="payment-form"
      :label-col="{ style: { width: '120px' } }"
    >
      <a-form-item label="客服二维码">
        <div class="input-upload-wrapper">
          <a-input
            v-model:value="config.wx_customer"
            placeholder="请输入客服二维码"
            class="custom-input"
          />
          <File-Upload v-model="config.wx_customer" />
        </div>
      </a-form-item>
      <a-form-item label="互助群二维码">
        <div class="input-upload-wrapper">
          <a-input
            v-model:value="config.wx_mutual_group"
            placeholder="请输入互助群二维码"
            class="custom-input"
          />
          <File-Upload v-model="config.wx_mutual_group" />
        </div>
      </a-form-item>
      <a-form-item label="快递查询api-key">
        <div class="input-upload-wrapper">
          <a-input
            v-model:value="config.delivery_api_key"
            placeholder="快递查询api-key"
          />
        </div>
      </a-form-item>
    </a-form>
    <div class="submit-button-wrapper">
      <a-button type="primary" @click="submitConfig" class="submit-button"
        >提交修改
      </a-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, reactive } from "vue";
import { ConfigService } from "@/api/services/ConfigService";
import { message } from "ant-design-vue";
import FileUpload from "@/components/FileUpload.vue";
import { Config } from "@/api/models/config/Config";

const config = reactive<Config>({});

const handleConfig = async () => {
  const res = await ConfigService.ConfigGet();
  if (res.code === 0) {
    Object.assign(config, res.data);
  } else {
    message.error(res.msg);
  }
};

const submitConfig = async () => {
  const res = await ConfigService.Config(config);
  if (res.code === 0) {
    message.success("系统配置修改成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

onMounted(async () => {
  await handleConfig();
});
</script>

<style scoped>
.container {
  border: 1px solid #d9d9d9;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 98%;
  margin-left: 1%;
  background-color: white;
  margin-top: 16px;
  margin-bottom: 16px;
}

.payment-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 24px;
  text-align: left;
}

.payment-form {
  width: 100%;
}

.payment-input {
  margin-left: 4px;
}

.payment-form .ant-form-item-label > label {
  color: #555;
  font-weight: 500;
}

.payment-form .ant-input {
  border-radius: 6px;
  font-size: 14px;
  padding: 8px 12px;
}

.payment-form .ant-input:focus {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.input-upload-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

.custom-input {
  width: 300px;
  margin-left: 4px;
}

.submit-button-wrapper {
  display: flex;
  justify-content: flex-start;
  margin-top: 24px;
  margin-left: 80px; /* 调整左边距，与表单标签对齐 */
}

.submit-button {
  width: 150px;
  height: 40px; /* 调整按钮高度 */
  font-size: 16px; /* 调整按钮字体大小 */
}
</style>
